var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMap = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 1.3749C43.9999 1.17155 43.9547 0.97076 43.8676 0.786993C43.7805 0.603226 43.6538 0.441059 43.4965 0.312175C43.3392 0.183292 43.1553 0.0909001 42.958 0.041657C42.7607 -0.00758604 42.5549 -0.0124546 42.3555 0.0274021L28.875 2.7224L15.3945 0.0274021C15.2166 -0.00815739 15.0334 -0.00815739 14.8555 0.0274021L1.1055 2.7774C0.793911 2.83968 0.513509 3.00796 0.311969 3.25361C0.110429 3.49927 0.000191901 3.80715 0 4.1249L0 42.6249C0.000122795 42.8283 0.045348 43.029 0.132417 43.2128C0.219487 43.3966 0.346232 43.5587 0.503523 43.6876C0.660814 43.8165 0.844734 43.9089 1.04203 43.9581C1.23933 44.0074 1.44509 44.0123 1.6445 43.9724L15.125 41.2774L28.6055 43.9724C28.7834 44.0078 28.9666 44.0078 29.1445 43.9724L42.8945 41.2224C43.2061 41.1601 43.4865 40.9918 43.688 40.7462C43.8896 40.5005 43.9998 40.1927 44 39.8749V1.3749ZM13.75 38.7474V3.0524L15.125 2.7774L16.5 3.0524V38.7474L15.3945 38.5274C15.2166 38.4917 15.0334 38.4917 14.8555 38.5274L13.75 38.7474ZM27.5 40.9474V5.2524L28.6055 5.4724C28.7834 5.50796 28.9666 5.50796 29.1445 5.4724L30.25 5.2524V40.9474L28.875 41.2224L27.5 40.9474Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/map.ca0df5481cd716298df583d5675265be.svg";